import type { SchoolDetail } from './types';

export const group1: Record<string, SchoolDetail> = {
  'tiba-netherlands': {
    slug: 'tiba-netherlands',
    lead:
      'オランダ・シンペルフェルトに校舎を置く The International Butler Academy（TIBA）。8週間・800時間の Private Butler Training を中核に、オールインクルーシブの学費体系と実践重視の学び方で知られる。',
    sections: [
      {
        heading: 'この学校の位置づけ',
        body: 'The International Butler Academy（TIBA）は、オランダ・シンペルフェルトに本校を置く国際的な執事学校です。公式サイト（butlerschool.com）を拠点に、Private Butler Training をはじめ複数の課程を提供しています。',
      },
      {
        heading: '開催地・拠点',
        body: '所在地は Pater Damiaanstraat 38, 6369 SV Simpelveld, The Netherlands です。オランダの校舎での訓練に加え、サルデーニャ島での1週間の研修が含まれます。',
        table: [
          { label: '所在地', value: 'Pater Damiaanstraat 38, 6369 SV Simpelveld, The Netherlands' },
          { label: '校外研修', value: 'サルデーニャ島での1週間の研修（航空券・宿泊込み）' },
        ],
      },
      {
        heading: '沿革と創設者',
        body: '公式サイトでは設立年の明記はありません。25周年への言及はあるものの、設立年は断定できません。',
        note: '設立年・創設者の詳細は公式サイトに記載なし',
      },
      {
        heading: '提供している課程',
        body: '公式が示す主な課程は次のとおりです。',
        bullets: [
          '8週間 Private Butler Training',
          '4週間 Luxury Hotel & Resort Training',
          'Train the Trainer（期間の記載なし）',
        ],
      },
      {
        heading: 'カリキュラムの科目',
        body: '8週間で800時間（公式「become a butler」ページ）。公式が列挙する科目は次のとおりです。',
        bullets: [
          '執事の生活',
          '現代の執事',
          '執事と人工知能',
          'スタッフ管理',
          'ハウス管理',
          'テーブル管理',
          'ランドリーとワードローブ管理',
          'ヴァレット技能',
          'コミュニケーション',
          'ペットとガーデニング',
          'エチケットとプロトコル',
          '料理',
          'その他（旅行・引越・ショーファー・警備・人格形成）',
        ],
      },
      {
        heading: '一日の流れ・学び方',
        body: '典型的には午前8時から午後8時まで。それより長くなる日も多い、と公式に記載されています。学び方については「毎日が実践の日。校内で行われるイベントは本物」とされ、受講生が持ち回りでヘッドバトラーを務め、その日の運営を統括するロールプレイを行います。',
        bullets: [
          '典型的な時間帯: 午前8時〜午後8時（それより長くなる日も多い）',
          '毎日が実践の日。校内イベントは本物として実施',
          '受講生が持ち回りでヘッドバトラーを務め、その日の運営を統括するロールプレイ',
        ],
      },
      {
        heading: '学費と支払条件',
        body: '公式 The Tuition Fee ページに基づく料金です。総額12,750ユーロ（約238万円・2026-07-27時点）（1日あたり227ユーロ（約4万2,000円・2026-07-27時点））。オールインクルーシブで、支払済み費用は返金不可（日程変更時は将来の受講に充当可能）です。為替換算は行いません。',
        table: [
          { label: '総額', value: '12,750ユーロ（約238万円・2026-07-27時点）（1日あたり227ユーロ（約4万2,000円・2026-07-27時点））' },
          { label: '申込金', value: '750ユーロ（約14万円・2026-07-27時点）' },
          { label: '残額', value: '12,000ユーロ（約224万円・2026-07-27時点）（開講60日前までに支払い）' },
          { label: '返金ポリシー', value: '支払済み費用は返金不可（日程変更時は将来の受講に充当可能）' },
        ],
        bullets: [
          'オランダの校舎での8週間の訓練',
          'サルデーニャ島での1週間の研修（航空券・宿泊込み）',
          '設備付き個室',
          '執事の制服一式と付属品',
          '全食事',
          '校外研修の交通費',
          'インターネット',
          'ジム利用',
          '卒業写真',
          '国際的に認められるディプロマ',
        ],
      },
      {
        heading: '定員と受講対象',
        body: 'サービス志向の姿勢と、この職業に相応しい人柄が求められます。定員の具体数は公式に明記されていません。',
        note: '定員の具体数は公式サイトに記載なし',
      },
      {
        heading: '応募資格と申込方法',
        body: '応募資格と申込方法は公式に次のとおり示されています。定員に限りがあるため早期応募が推奨されます。',
        bullets: [
          '18歳以上',
          '英語の実用的な知識（全授業が英語）',
          '訓練歴・実務経験は不要',
          'サービス志向の姿勢と、この職業に相応しい人柄',
          '履歴書・近影・希望プログラムを butlerschool@butlerschool.com へ送付',
        ],
      },
      {
        heading: '宿泊と食事',
        body: '学費はオールインクルーシブで、設備付き個室と全食事が含まれます。',
        bullets: ['設備付き個室', '全食事'],
      },
      {
        heading: '認定・受賞',
        body: '公式が示す受賞歴は次のとおりです。',
        bullets: [
          'Capital Finance International「The Best Butler School in the World」(2019-2020)',
          'Corporate Livewire Global Award「Specialist Education & Training Provider of the Year」(2021-2025)',
        ],
      },
      {
        heading: '修了後の進路と就職支援',
        body: '自社の人材紹介部門があります。就職・インターンシップの斡旋、求人掲載を行います。',
        bullets: ['自社の人材紹介部門', '就職・インターンシップの斡旋', '求人掲載'],
      },
      {
        heading: '言語',
        body: '全授業が英語で行われます。応募資格として英語の実用的な知識が求められます。',
      },
    ],
    sources: [
      { label: 'The International Butler Academy 公式', url: 'https://www.butlerschool.com/' },
    ],
  },

  'tiba-china': {
    slug: 'tiba-china',
    lead:
      '2014年7月10日に開校した The International Butler Academy China。四川省成都の高級住宅地にある私邸ヴィラを校舎とし、中国国籍者を対象に6週間のバトラー・ホスピタリティ課程を英語と中国語で提供する。',
    sections: [
      {
        heading: 'この学校の位置づけ',
        body: 'The International Butler Academy China は、TIBA の中国拠点です。アジアのサービス専門職向けに設計されたバトラー・ホスピタリティ課程を提供します。「中国初の常設・認定バトラースクール」と自ら称しています（自己申告）。',
      },
      {
        heading: '沿革と創設者',
        body: '2014年7月10日に開校しました。開校式は成都・環球中心のインターコンチネンタルホテルで開催され、オランダ総領事 Tieleman 氏がテープカットを行いました。豪州・スイス・英国・オランダの大使や、CEO・ホテル支配人らが出席しています。',
        bullets: [
          '開校日: 2014年7月10日',
          '開校式会場: 成都・環球中心のインターコンチネンタルホテル',
          'オランダ総領事 Tieleman 氏によるテープカット',
          '出席: 豪州・スイス・英国・オランダの大使、CEO・ホテル支配人ら',
        ],
        note: '校長・創設者の氏名等は公式サイトに記載なし',
      },
      {
        heading: '開催地・拠点',
        body: '四川省成都の高級住宅地にある私邸ヴィラを校舎としています。',
        table: [
          { label: '所在', value: '四川省成都（高級住宅地の私邸ヴィラ）' },
          { label: '公式', value: 'https://www.butlerschool.com/the-extras/tiba-china/' },
          { label: '別サイト', value: 'www.butlerschool.com.cn' },
        ],
      },
      {
        heading: '施設',
        body: '校舎は私邸ヴィラで、次の施設が公式に挙げられています。',
        bullets: [
          '広い研修室',
          '寝室',
          '設備の整ったバー',
          '西洋式と中華式のモダンなキッチン',
          'プール',
          'サウナ',
        ],
      },
      {
        heading: '提供している課程',
        body: '6週間のバトラー・ホスピタリティ課程を提供します。アジアのサービス専門職向けに設計されています。',
        table: [{ label: '期間', value: '6週間' }],
      },
      {
        heading: '学費と支払条件',
        note: '公式サイトに記載なし',
      },
      {
        heading: '定員と受講対象',
        body: '受講対象は中国国籍者に限定されています。',
        bullets: ['中国国籍者に限定'],
        note: '定員の具体数は公式サイトに記載なし',
      },
      {
        heading: '宿泊と食事',
        body: '校舎となる私邸ヴィラに寝室があります。食事に関する詳細な条件は公式の記載を確認できません。',
        note: '宿泊・食事の料金条件等の詳細は公式サイトに記載なし',
      },
      {
        heading: '言語',
        body: '英語と中国語の両方で行われます（英中バイリンガル）。',
        bullets: ['英語', '中国語'],
      },
      {
        heading: '認定・受賞',
        body: '「中国初の常設・認定バトラースクール」と自ら称しています（自己申告）。',
      },
      {
        heading: '修了後の進路と就職支援',
        note: '公式サイトに記載なし',
      },
    ],
    sources: [
      {
        label: 'TIBA China（公式 extras ページ）',
        url: 'https://www.butlerschool.com/the-extras/tiba-china/',
      },
    ],
  },

  'butler-training-institute': {
    slug: 'butler-training-institute',
    lead:
      'オランダ・ローヘムに拠点を置く The International Butler Training Institute B.V.。創設者 Cornelis Greveling 氏のもと、「Learning By Doing」を掲げ、少人数制のバトラー訓練（12日間・3週間・2か月など）を提供する。',
    sections: [
      {
        heading: 'この学校の位置づけ',
        body: 'The International Butler Training Institute B.V. は、オランダ・ローヘムに所在する執事訓練機関です。「世界で最も小さく最も少人数の執事学校」と自ら称しています（自己申告）。標語は「Distinctly different」「Learning By Doing」です。',
        bullets: [
          '標語: 「Distinctly different」',
          '標語: 「Learning By Doing」',
          '中核価値: Mindset',
          '中核価値: Personal Training – Coaching',
          '中核価値: Learning by doing',
          '中核価値: Development',
        ],
      },
      {
        heading: '沿革と創設者',
        body: '創設者は Cornelis Greveling 氏です。公式に「TIBA の元トレーナー、ヘッドバトラー、パーソナルバトラー」と記載され、「Grand Master in Hospitality and Butler Service」として授業を統括します。',
        bullets: [
          '創設者: Cornelis Greveling 氏',
          'TIBA の元トレーナー・ヘッドバトラー・パーソナルバトラー',
          'Grand Master in Hospitality and Butler Service として授業を統括',
        ],
      },
      {
        heading: '開催地・拠点',
        body: 'オランダ・ローヘムに拠点を置きます。',
        table: [
          { label: '所在地', value: 'Marinus Naefflaan 11, 7241 GC Lochem, Netherlands' },
          { label: '電話', value: '+31 85 0603604' },
          { label: '商業会議所番号', value: '80517463' },
        ],
      },
      {
        heading: '提供している課程',
        body: '公式が示す課程は次のとおりです。バトラー訓練は12日間・3週間・2か月の期間設定があります。',
        bullets: [
          'バトラー訓練（12日間）',
          'バトラー訓練（3週間）',
          'バトラー訓練（2か月）',
          'プライベートバトラー訓練',
          'ホテル向け訓練',
          'ワークショップ',
          '中国向け訓練',
        ],
      },
      {
        heading: '学費と支払条件',
        body: '公式FAQに基づく料金です。12日間コースは4,450ユーロ（約83万円・2026-07-27時点）。為替換算は行いません。',
        table: [{ label: '12日間コース', value: '4,450ユーロ（約83万円・2026-07-27時点）' }],
        bullets: [
          '昼食・夕食',
          '日中のコーヒーと紅茶',
          '校外研修',
          '全教材',
          '執事の制服一式',
        ],
      },
      {
        heading: '定員と受講対象',
        body: '定員は「最大5名」を目標とし、現状は最大10名です。「世界で最も小さく最も少人数の執事学校」と自ら称しています（自己申告）。対象となる職種志向は次のとおりです。',
        bullets: [
          '定員目標: 最大5名（現状は最大10名）',
          'private butler',
          'steward',
          'valet',
          'hotel butler',
          'house manager',
          'estate manager',
        ],
      },
      {
        heading: '応募資格と申込方法',
        note: '応募資格・年齢制限・開講日は公式サイトに記載なし',
      },
      {
        heading: '宿泊と食事',
        body: '12日間コースの学費に昼食・夕食、日中のコーヒーと紅茶が含まれます。宿泊については公式の記載がありません。',
        bullets: ['昼食・夕食（12日間コースに含む）', '日中のコーヒーと紅茶（12日間コースに含む）'],
        note: '宿泊は公式サイトに記載なし',
      },
      {
        heading: '修了後の進路と就職支援',
        body: '公式FAQによれば、12日間で90%がディプロマまたは証明書を取得して修了します。平均して75%の受講生が就職し、修了前に決まる者もいます。人材紹介会社との連携と求人バンクがあります。',
        table: [
          { label: '修了率', value: '12日間で90%がディプロマまたは証明書を取得して修了' },
          { label: '就職率', value: '平均して75%の受講生が就職' },
        ],
        bullets: ['人材紹介会社との連携', '求人バンクあり', '修了前に就職が決まる者もいる'],
      },
      {
        heading: '言語',
        note: '使用言語は公式サイトに記載なし',
      },
    ],
    sources: [
      { label: 'Butler Training Institute 公式', url: 'https://butlertraininginstitute.com/' },
      { label: 'Butler Training Institute FAQ', url: 'https://butlertraininginstitute.com/faq/' },
    ],
  },
};
